/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Aman's Portfolio",
  description:
    "A curious student dabbling in the field of machine learning and android development. I'm always ready to take up projects and determined to complete them successfully. I love to interact with people by taking webinars, hosting sessions, participating and mentoring in hackathons. My hobbies and interests range from pop songs to brain machine interfaces.",
  og: {
    title: "Aman Ali's Portfolio",
    type: "website",
    url: "https://github.com/a-ma-n",
  },
};

//Home Page
const greeting = {
  title: "Aman Ali Siddiqui",
  //   nickname:"Aman",
  logo_name: "AS",
  subTitle: "A curious student dabbling in the vast fields of Technology.",
  resumeLink: "https://bit.ly/Aman-Alis-Resume",
  portfolio_repository: "https://github.com/a-ma-n",
  githubProfile: "https://github.com/a-ma-n",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/a-ma-n",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/-aman/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:amanalisiddiqui.contact@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/NotOkAman",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
];

const skills = {
  data: [
    {
      title: "Machine Learning, Android Development, Problem Solving & Cloud",
      fileName: "FullStackImg",
      skills: [
        "📍 Training Machine Learning and Deep Learning models and deploying them using Docker and Microsoft Azure",
        "📍 Experienced with creating Android Applications with  Kotlin and Firebase",
        "📍 Analysing and tuning Data Science Projects, Machine Learning & Deep Learing Models using Tensorflow",
        "📍 Process images with OpenCV and Deep Learning Models",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#02569B",
          },
        },
        // {
        // skillName: "Sci-Kit Learn",
        // fontAwesomeClassname: "simple-icons:scikit-learn",
        // style: {
        //   color: "#E34F26",
        // },
        // },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#1DA1F2",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "##00599C",
          },
        },
        // {
        //   skillName: "Java",
        //   fontAwesomeClassname: "simple-icons:java",
        //   style: {
        //     color: "##FF7800",
        //   },
        // },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "simple-icons:kotlin",
          style: {
            color: "##7F52FF",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },

        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            color: "#5C3EE8",
          },
        },
        {
          skillName: "Github",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },
        {
          skillName: "Google Colab",
          fontAwesomeClassname: "simple-icons:googlecolab",
          style: {
            color: "#F9AB00",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            color: "#F9AB00",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#000000",
      },
      profileLink: "https://leetcode.com/a-ma-n/",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/a-ma-n",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/a_m_an",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/aman_la_mart",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://www.kaggle.com/amanalisiddiqui",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Vellore Institute of Technology, Vellore",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "logo.png",
      alt_name: "Vellore Institute of Technology, Vellore",
      duration: "2020 - Present",
      descriptions: [
        " 📍 I have studied various core Computer Science subjects like Data Structures, Algorithms, Operating Systems, Databases & Networks.",
        " 📍 I actively engage with various communities and grow and learn with them. ",
      ],
      website_link: "https://vit.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have a great experience of working with these companies & creating impact, which in turn has helped me a lot to explore my skillset and gain exposure.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      experiences: [
        {
          title: "Technical Intern",
          company: "Piramal Finance",
          company_url: "https://www.sap.com/india/about/labs-india.html",
          logo_path: "piramal_finance.jpeg",
          duration: "May 2023 - July 2023 & January 2024 - June 2024",
          location: "Bangalore",
          description:
            "Worked on metrics dashboard website which shows different metrics for tests & automation thorughout the organisation, using React, Redux, Material UI, Spring Boot, MongoDB, JQL & ChartJS. Reduced the fetching time of APIs by more than 65% with parallelization. Reduced site load times from 22s to 7s. Created Gen AI APIs & UIs in NextJS for generating test data.",
          color: "#0879bf",
        },
        {
          title: "Machine Learning Intern",
          company: "SAP Labs India",
          company_url: "https://www.sap.com/india/about/labs-india.html",
          logo_path: "saplabs.jpeg",
          duration: "May 2022 - July 2022",
          location: "Remote",
          description:
            "Spearheaded the development of ML-Launchpad and AI core SDK API endpoints, using the Python SDK and TypeScript. Worked on the API, which used HANA as the database and was deployed on Kubernetes. Extended an endpoint to recommend graphs to the users, depending on the metrics used by the Data Scientists.",
          color: "#0879bf",
        },
        {
          title: "Machine Learning (Computer Vision) & EDGE devices Intern",
          company: "Shoproxx Technologies Pvt. Ltd.",
          company_url: "https://www.prishapolicy.com/",
          logo_path: "shoprox.webp",
          duration: "June 2021 - July 2021",
          location: "Remote",
          description:
            "Used Jetson Nano (EDGE device) to measure the quantity of stock (pizzas) required by a shop by capturing details from the camera.I was responsible for the machine learning model selection suitable for our use-case which was Mobilenet SSD - 14.0 MB.Calculated the metrics based on the data collected by the object detection model and used MongoDB for storing them, and setting up the routes using Flask.",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Organisations",
      experiences: [
        {
          title: "Secretary",
          company: "Indian Society for Technical Education",
          company_url: "https://istevit.in/",
          logo_path: "iste.png",
          duration: "December 2020 - Present",
          location: "VIT, Vellore",
          description: "",
          color: "#4285F4",
        },
        {
          title: "Gold Microsoft Learn Student Ambassador",
          company: "Microsoft Learn",
          company_url: "https://studentambassadors.microsoft.com/",
          logo_path: "goldmlsa.jpeg",
          duration: "April 2021 - Present",
          location: "",
          description: "",
          color: "#4285F4",
        },
        {
          title: "Edge Insiders Track Leader",
          company: "Edge x MLSA Community",
          company_url: "https://studentambassadors.microsoft.com/",
          logo_path: "mlsabadge.jpeg",
          duration: "October 2021 - Present",
          location: "",
          description: "",
          color: "#4285F4",
        },
        {
          title: "Amazon ML Summer School Participant",
          company: "Amazon",
          company_url: "https://www.amazon.in/",
          logo_path: "amazon.png",
          duration: "February 2022 - July 2022",
          location: "",
          description: "",
          color: "#4285F4",
        },
        {
          title: "Core Member",
          company: "Student Technical Community",
          company_url: "https://stcvit.in/",
          logo_path: "stclogo.png",
          duration: "December 2020 - Present",
          location: "VIT, Vellore",
          description: "",
          color: "#4285F4",
        },
      ],
    },
    {
      title: "Achievements",
      experiences: [
        {
          title: "3rd at GDSC NMIMS Hackathon",
          company: "GDSC NMIMS",
          company_url: "",
          logo_path: "gdscnmims.png",
          duration: "June 2022",
          location: "",
          description: "",
          color: "#4285F4",
        },
        {
          title: "3rd Honeywell  WIE-VIT Hackathon",
          company: "Honeywell",
          company_url: "",
          logo_path: "honeywell.png",
          duration: "April 2022",
          location: "",
          description: "",
          color: "#4285F4",
        },
        {
          title: "1st at the Unscript Rookies Hackathon",
          company: "Fr. Conceicao Rodrigues College of Engineering, Bandra (W)",
          company_url: "",
          logo_path: "unscript.jpeg",
          duration: "January 2022",
          location: "",
          description: "",
          color: "#4285F4",
        },
        {
          title: "1st Position in I3 Skillship Vellore",
          company: "Skillship vellore",
          company_url: "",
          logo_path: "skillship.png",
          duration: "December 2021",
          location: "",
          description: "",
          color: "#4285F4",
        },
        {
          title: "Runner Up in the internal MLSA Pitching Competition",
          company: "Microsoft Learn Student Ambassadors",
          company_url: "",
          logo_path: "mlsabadge.jpeg",
          duration: "October 2021",
          location: "",
          description: "",
          color: "#4285F4",
        },
      ],
    },
    // {
    //   title: "Research Papers",
    //   experiences: [
    //     {
    //       title: "Converting SAR Images to Optical Images Using CycleGAN",
    //       company:
    //         " 2024 Second International Conference on Emerging Trends in Information Technology and Engineering (ICETITE)",
    //       company_url: "https://ieeexplore.ieee.org/document/10493784",
    //       logo_path: "honeywell.png",
    //       duration: "April 2022",
    //       location: "",
    //       description: "",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Visualizing Optimal Classifiers in EEG-Based Sleepy Driver Prediction",
    //       company:
    //         "Third International Conference, ANTIC 2023, Varanasi, India, December 20-22, 2023, Proceedings, Part III",
    //       company_url: "https://link.springer.com/book/9783031640698",
    //       logo_path: "",
    //       duration: "Feburary 2024",
    //       location: "",
    //       description: "",
    //       color: "#4285F4",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of vast variety of latest technology tools. My best skill is to create ML API's with Flask and deploy them to web applications using cloud infrastructure like Azure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "amanprofile.png",
    description:
      " You can hit me up on these social media channels,and I will reply within 24 hours. I can help you with Machine Learning,Deep Learning , Android Development, Cloud & Data Structures and Algorithms.",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
